import styles from "./Description.module.scss";
import Text from "../Typography/Text/Text";

export default function Advantages() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.main}>
            <Text size="normal">
              <strong>Электрозаправочные станции</strong> – это удобный и
              экологичный способ зарядки вашего электромобиля.
            </Text>
          </div>
          <div className={styles.description}>
            <Text size="normal">
              Наши электрозаправочные станции представляют собой оборудование,
              которое обеспечивает электроэнергию для зарядки подключаемых
              электромобилей.
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
